/** A marca do produto — a Oficina Fraterna.
 *
 * Nada é recomposto aqui: o guia da marca pede que se usem os arquivos, e eles
 * vêm do kit (`marca/kit/logo/svg/transparente/`) para `public/marca/`. Por
 * isso são `<img>` e não SVG embutido — o nome está em caminhos, não em fonte,
 * e inline custaria 75 KB de bundle por assinatura.
 *
 * Não confundir com `Marca.tsx`, que é o **brasão da Loja**. O guia é explícito:
 * em tela, o brasão da Loja é o protagonista; esta marca aparece onde a Loja
 * ainda não entrou — a tela de acesso — e no rodapé, discreta.
 */

type Tom = 'cor' | 'negativa';

const SUFIXO: Record<Tom, string> = { cor: '', negativa: '-negativa' };

export function LogoOficinaFraterna({
  tom = 'cor',
  altura = 44,
  /** Com o slogan "Gestão a serviço da fraternidade" sob o nome. */
  comSlogan = false,
  className,
}: {
  tom?: Tom;
  altura?: number;
  comSlogan?: boolean;
  className?: string;
}) {
  const base = comSlogan ? 'horizontal-slogan' : 'horizontal';
  return (
    <img
      src={`/marca/${base}${SUFIXO[tom]}.svg`}
      alt="Oficina Fraterna"
      className={className}
      style={{ height: altura, width: 'auto', display: 'block' }}
    />
  );
}

export function SimboloOficinaFraterna({
  tom = 'cor',
  tamanho = 32,
  className,
}: {
  tom?: Tom;
  tamanho?: number;
  className?: string;
}) {
  return (
    <img
      src={`/marca/simbolo${SUFIXO[tom]}.svg`}
      alt="Oficina Fraterna"
      className={className}
      style={{ width: tamanho, height: tamanho, display: 'block' }}
    />
  );
}
